import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      disabelConfirm: false,
      hospitalReportTableInformationHeader: [
        {
          text: '',
          value: 'icon',
          align: 'center',
          width: '30px',
          sortable: false,
        },
        { text: 'تاریخ', value: 'date', align: 'center', width: '150px' },
        {
          text: 'کد آمبولانس',
          value: 'ambulanceCode',
          align: 'center',
          width: '120px',
        },
        {
          text: 'نام و نام خانوادگی',
          value: 'fullName',
          align: 'center',
          width: '200px',
        },
        { text: 'آدرس', value: 'address', align: 'center', width: '400px' },
        {
          text: 'بیمارستان',
          value: 'hospital',
          align: 'center',
          width: '150px',
        },
        {
          text: 'مشاهده پرونده',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: '120px',
        },
      ],
      hospitalReportMissions: [],
      missionPhoneId: null,
      missionId: null,
      phoneId: null,
      patientId: null,
      //search
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchHospitalId: null,
      searchAmbulanceCode: '',
      searchFullName: '',
      isSearch: false,
      searchModal: false,
    };
  },
  methods: {
    //search
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getListOfHospitalAdmissionsWithPaginationReportFunction();
    },
    removeFilters: function () {
      this.searchHospitalId = null;
      this.searchAmbulanceCode = '';
      this.searchFullName = '';
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getListOfHospitalAdmissionsWithPaginationReportFunction();
    },
    cancelSearch: function () {
      this.searchHospitalId = null;
      this.searchAmbulanceCode = '';
      this.searchFullName = '';
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    setActionType: function (type, data) {
      if (type == 'ترومایی مرتبط با حمل و نقل') {
        let id = data.id + '-' + data.patientId + '-' + 1;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else if (type == 'ترومایی غیرمرتبط با حمل و نقل') {
        let id = data.id + '-' + data.patientId + '-' + 2;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else if (type == 'سکته مغزی') {
        let id = data.id + '-' + data.patientId + '-' + 3;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else if (type == 'مشکلات قلبی') {
        let id = data.id + '-' + data.patientId + '-' + 4;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      } else {
        let id = data.id + '-' + data.patientId + '-' + 5;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      }
    },
    exportMission: function (missionPhoneId, patientId, type, flag) {
      if (flag == false) {
        if (type[0] == 'ترومایی مرتبط با حمل و نقل') {
          let id = missionPhoneId + '-' + patientId + '-' + 1;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else if (type[0] == 'ترومایی غیرمرتبط با حمل و نقل') {
          let id = missionPhoneId + '-' + patientId + '-' + 2;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else if (type[0] == 'سکته مغزی') {
          let id = missionPhoneId + '-' + patientId + '-' + 3;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else if (type[0] == 'مشکلات قلبی') {
          let id = missionPhoneId + '-' + patientId + '-' + 4;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        } else {
          let id = missionPhoneId + '-' + patientId + '-' + 5;
          this.$router.push({
            name: 'hospitalMissionReportExport',
            params: { id: id },
          });
        }
      } else if (flag == null) {
        let id = missionPhoneId + '-' + 0 + '-' + 6;
        this.$router.push({
          name: 'hospitalMissionReportExport',
          params: { id: id },
        });
      }
    },
  },
};
